export default __webpack_public_path__ + "static/sprite-9eec72e45f36d02879b990756734f700.svg";